import { ISalesLink } from '../../../types/salesLink';
import { IApplicationState } from '../../../types/redux';

export const getSalesLinks = (state: IApplicationState): ISalesLink[] => {
  return state.mainpage.salesLinks || [];
};
